import { Box } from "@mui/material";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import CurrencyBitcoinIcon from "@mui/icons-material/CurrencyBitcoin";
import { useLocale, useTranslations } from "next-intl";
import AlipayIcon from "@/app/components/AlipayIcon";
import WechatPayIcon from "@/app/components/WechatPayIcon";

export type PaymentMethod = "creditCard" | "alipayWechat" | "crypto";

export interface PaymentOption {
  method: PaymentMethod;
  label: string;
  icon: React.ReactNode;
}

/**
 * 支付选项配置 Hook
 * 统一管理 PaymentMethods 和 PaymentDialog 的支付选项
 */
export function usePaymentOptions(): PaymentOption[] {
  const t = useTranslations("Membership");
  const locale = useLocale();

  const paymentOptions: PaymentOption[] = [
    {
      method: "creditCard",
      label: t("payment.methods.creditCard"),
      icon: <CreditCardIcon sx={{ width: "1.5rem", height: "1.5rem" }} />,
    },
    {
      method: "crypto",
      label: t("payment.methods.crypto"),
      icon: (
        <CurrencyBitcoinIcon
          sx={{
            width: "1.5rem",
            height: "1.5rem",
            borderRadius: "50%",
            bgcolor: "text.primary2",
            color: "background.paperMedium",
            padding: "2px",
          }}
        />
      ),
    },
  ];

  // 仅在简体中文环境下添加支付宝微信选项
  if (locale.toLowerCase() === "zh-cn") {
    paymentOptions.splice(1, 0, {
      method: "alipayWechat",
      label: t("payment.methods.alipayWechat"),
      icon: (
        <Box sx={{ display: "flex", alignItems: "center", gap: { xs: 1, sm: 2 } }}>
          {/* <AlipayIcon /> */}
          <WechatPayIcon />
        </Box>
      ),
    });
  }

  return paymentOptions;
}
